import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";

import { Box, Card, CardContent } from "@mui/material";

import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";

import AppLogo from "@/assets/images/favicon.png";
import HeroImage from "@assets/images/onboarding/gradient-light.svg?url";
import { ErrorPageType } from "@/enum";

import { Button } from "../Button/Button";
import { Icon } from "../Icon/Icon";

interface NoMobilePageProps {
	type: ErrorPageType;
}

export const NoMobilePage: FunctionComponent<NoMobilePageProps> = () => {
	const navigate = useNavigate();

	return (
		<Box
			id="portal-auth"
			sx={{
				width: "100vw",
				height: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexDirection: "column",
			}}
		>
			<Box
				alt="Background image"
				component="img"
				src={HeroImage}
				sx={{
					width: "100%",
					height: "100%",
					position: "fixed",
					inset: 0,
					zIndex: -1,
					objectFit: "cover",
				}}
			/>
			<div className="w-full flex flex-col items-center">
				<div className="w-full z-10 flex flex-col px-4 justify-center items-center mb-8">
					<Card
						elevation={16}
						sx={{
							mb: 4,
							position: "relative",
							width: "100%",
							maxWidth: "444px",
						}}
					>
						<CardContent>
							<div className="flex flex-col items-center mb-4">
								<img alt="logo" className="w-20 h-20" src={AppLogo} />
							</div>
							<div className="flex flex-col items-center mb-4">
								<Icon className="text-blue-action w-12 h-12" icon={faTriangleExclamation} />
							</div>
							<div className="text-md font-bold text-center mb-2">
								You can only use Signalist
								<br />
								on desktop!
							</div>
							<div className="text-smd text-text-meta text-center mb-8">
								But you can still start your sign up on mobile and continue your onboarding on
								desktop later
							</div>
							<div className="text-smd text-text-meta text-center mb-8">
								<Button className="w-full" title="Sign up" onClick={() => navigate("/register")} />
							</div>
						</CardContent>
					</Card>
				</div>
			</div>
		</Box>
	);
};
